import React, { useEffect } from "react";
import { showPmrWarning } from "../utils/swalUtils";

export default function CustomAlertModal({ show, onHide, message }) {
  useEffect(() => {
    if (show) {
      showPmrWarning(message).then(() => {
        if (onHide) onHide();
      });
    }
  }, [show, message, onHide]);

  return null;
}
